const OPTIONS = [
  { key: "ptt", label: "Press & speak" },
  { key: "free", label: "Flowing" },
];

// Two equal segments so the moving highlight can never clip a label.
export const ModeSwitch = ({ convo, toggleConvo, full }) => (
  <div
    data-testid="convo-toggle-btn"
    role="group"
    aria-label="Speaking mode"
    className={`relative grid grid-cols-2 rounded-full p-[3px] ${full ? "w-full" : "w-[238px]"}`}
    style={{ border: "1px solid var(--border-linen)", background: "rgba(12,12,11,0.45)" }}
  >
    <span
      aria-hidden
      className="pointer-events-none absolute bottom-[3px] top-[3px] w-[calc(50%-3px)] rounded-full transition-[left,background-color,border-color,box-shadow] duration-500"
      style={{
        left: convo ? "50%" : "3px",
        transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
        background: convo ? "color-mix(in srgb, var(--lab-accent) 22%, transparent)" : "rgba(244,239,230,0.07)",
        border: `1px solid ${convo ? "color-mix(in srgb, var(--lab-accent) 55%, transparent)" : "rgba(244,239,230,0.08)"}`,
        boxShadow: convo ? "0 0 18px color-mix(in srgb, var(--lab-accent) 26%, transparent)" : "none",
      }}
    />

    {OPTIONS.map((o) => {
      const on = (o.key === "free") === !!convo;
      return (
        <button
          key={o.key}
          data-testid={`mode-${o.key}-btn`}
          onClick={() => { if (!on) toggleConvo(); }}
          aria-pressed={on}
          className="relative z-10 truncate rounded-full px-2 py-[7px] text-center font-mono text-[9.5px] uppercase tracking-[0.14em] transition-colors duration-300"
          style={{ color: on ? (convo ? "var(--lab-accent)" : "var(--text-main)") : "var(--text-faint)" }}
        >
          {o.label}
        </button>
      );
    })}

    <span className="sr-only" data-testid="convo-toggle-value">{convo ? "Flowing conversation on" : "Press and speak"}</span>
  </div>
);
